module.exports = __webpack_public_path__ + "static/media/reblozyl_logo.27b72fe2.svg";